export default {
  fullName: 2,
  tagline: 2,
  phoneNumber: 2,
  email: 2,
  address: 2,
  objective: 3,
  personalLinks: 3,

  workExperience: 5,
  education: 6,
  skills: 4,
  projects: 6,
  awardsAndHonors: 5,
  volunteerWork: 6,
  certifications: 5,
  hobbiesAndInterests: 4,
  leadership: 6,
  associations: 6,
  languages: 4,
  publications: 4,
  courses: 5,
  conferences: 5,
  patents: 5,
  testScores: 5,
  references: 4,
  summary: 2,

  senderName: 1,
  senderPhoneNumber: 1,
  senderTagline: 1,
  senderAddress: 1,
  senderEmail: 1,
  receiverName: 1,
  receiverTagline: 1,
  receiverOrganization: 1,
  receiverAddress: 1,
  letterDate: 1,
  letterBody: 3,
  subjectLine: 1,
  openGreeting: 1,
  closeGreeting: 1,

  userPreferences: 10,
};
